/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react'

import Gantt, {
  Tasks,
  // Dependencies,
  // Resources,
  // ResourceAssignments,
  Column,
  Editing,
  Toolbar,
  Item,
  ContextMenu,
  // Validation,
  // Texts,
} from 'devextreme-react/gantt'
import { Popup } from 'devextreme-react/popup'
import {
  getImplementationScheduleByForm,
  getValidationImplementationActivityElegibility,
} from '../../../../../services/Elegibilidad/get'
import { insertImplementationSchedule } from '../../../../../services/Elegibilidad/create'
import swal from 'sweetalert'
import { UpdateImplementationSchedule } from '../../../../../services/Elegibilidad/put'

import { deleteImplementationSchedule } from '../../../../../services/Elegibilidad/delete'
import { Grid, FormControl, TextField, Button } from '@material-ui/core'
import { Stack } from '@mui/material'
import Moment from 'moment'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import { locale, loadMessages } from 'devextreme/localization'
import deMessages from 'devextreme/localization/messages/de.json'
import './style.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ReactTooltip from 'react-tooltip'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

const GantChartExtreme = ({
  formik,
  ImplementationDateStart,
  ImplementationDateEnd,
}) => {
  loadMessages({
    es: {
      Yes: 'Sí',
      'dxCollectionWidget-noDataText': 'No hay registros a desplegar',
      'dxDataGrid-noDataText': 'No hay registros a desplegar',
      'No data': 'No hay registros a desplegar',
      'dxListEditDecorator-delete': 'Eliminar',
      'dxDataGrid-editingDeleteRow': 'Eliminar',
      'dxDataGrid-editingConfirmDeleteMessage':
        '¿Está seguro que desea eliminar este registro?',
      'dxScheduler-confirmRecurrenceDeleteMessage':
        '¿Quiere eliminar solo esta cita o toda la serie?',
      'dxScheduler-confirmRecurrenceDeleteSeries': 'Eliminar serie',
      'Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?':
        'Eliminar',
      'dxDataGrid-editingUndeleteRow': 'ff',
      'dxGantt-dialogTaskDeleteConfirmation':
        '¿Está seguro que desea eliminar este registro?',
      'dxGantt-dialogDependencyDeleteConfirmation': 'prueba2',
      'dxGantt-dialogResourcesDeleteConfirmation': 'prueba3',
      'dxGantt-dialogStartTitle': 'Inicio',
      'dxGantt-dialogEndTitle': 'Fin',
      'dxGantt-dialogTaskDetailsTitle': 'Editar',
      'dxGantt-contextMenuDeleteTask': 'Eliminar actividad',
      'dxGantt-zoomIn': 'Ampliar',
      'dxGantt-zoomOut': 'Alejar',
      'dxGantt-deleteSelectedTask': 'Elimimar actividad',
    },
  })
  locale('es')

  const { idElegibilityForm, EligibilityForm } = useFormElegibilidad()
  const [tasks, setTasks] = useState([])
  const [popupVisible, setPopupVisible] = useState(false)
  const [activity, setActivity] = useState('')
  const [dateStart, setdateStart] = useState('')
  const [dateEnd, setdateEnd] = useState('')
  const [idActivity, setidActivity] = useState('')
  const [loading, setLoading] = useState(false)
  const [errorActividad, setErrorActividad] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    Activity: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(100, 'Máximo 100 caracteres'),
    dateStart: Yup.date().required('Este campo es obligatorio'),
    dateEnd: Yup.date()
      .required('Este campo es obligatorio')
      .min(
        ImplementationDateStart,
        `La fecha fin no debe ser menor al período estimado de implementación del proyecto.`,
      )
      .max(
        ImplementationDateEnd,
        `La fecha fin no debe ser mayor al período estimado de implementación del proyecto.`,
      ),
  })

  const formikTable = useFormik({
    validateOnChange: false,
    enableReinitialize: true,
    initialValues: {
      Activity: '',
      dateStart: Moment(ImplementationDateStart)
        .format('YYYY-MM-DD')
        .toString(),
      dateEnd: '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: () => {
      handleInsert()
    },
  })

  const validateFormStatus = () => {
    formikTable
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formikTable.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const getTasksList = async () => {
    try {
      // toDo cambiar el id
      const response = await getImplementationScheduleByForm(idElegibilityForm)
      // setTasks(response.Data)
      var item = []
      for (var i = 0; i < response.Data.length; i++) {
        item[i] = {
          id: response.Data[i].IdImplementationSchedule,
          parentId: 0,
          title: response.Data[i].Activity,
          start: new Date(response.Data[i].StartDate),
          end: new Date(response.Data[i].EndDate),
        }
      }
      setTasks(item)
      getValidation()
    } catch (error) {
      console.log(error)
    }
  }

  const getValidation = async () => {
    try {
      const response = await getValidationImplementationActivityElegibility(
        idElegibilityForm,
        ImplementationDateStart,
        ImplementationDateEnd,
      )
      if (response.Success) {
        if (response.Data.Message) {
          formik('validateGant', false)
        } else {
          formik('validateGant', true)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getTasksList()
  }, [idElegibilityForm])

  const handleInsert = async () => {
    setLoading(true)
    if (
      Moment(formikTable.values.dateEnd) > Moment(formikTable.values.dateStart)
    ) {
      if (idActivity === '') {
        const body = {
          IdImplementationSchedule: 0,
          IdElegibilityAnswer: idElegibilityForm,
          Activity: formikTable.values.Activity,
          StartDate: formikTable.values.dateStart,
          EndDate: formikTable.values.dateEnd,
          IdElegibilityAnswerNavigation: null,
        }

        const response = await insertImplementationSchedule(body)

        if (response.Success) {
          swal({
            title: '¡Datos guardados exitosamente!',
            icon: 'success',
          })
          getTasksList()
          onHiding()
          setidActivity('')
        }
      } else {
        const body = {
          IdImplementationSchedule: idActivity,
          IdElegibilityAnswer: idElegibilityForm,
          Activity: formikTable.values.Activity,
          StartDate: formikTable.values.dateStart,
          EndDate: formikTable.values.dateEnd,
          IdElegibilityAnswerNavigation: null,
        }

        const response = await UpdateImplementationSchedule(body)

        if (response.Success) {
          swal({
            title: '¡Datos actualizados exitosamente!',
            icon: 'success',
          })
          onHiding()
          getTasksList()
          setActivity('')
          setdateEnd('')
          setdateStart('')
          setidActivity('')
        }
      }
    } else {
      swal({
        title:
          'Favor validar las fecha  ingresadas y que la fecha fin  sea mayor a la fecha de inicio',
        icon: 'warning',
        button: 'Entendido',
      })
    }
    setLoading(false)
  }

  const handleDelete = async (e) => {
    try {
      const body = {
        IdImplementationSchedule: e.values.id,
        IdElegibilityAnswer: idElegibilityForm,
      }

      const response = await deleteImplementationSchedule(body)

      if (response.Success) {
        swal({
          title: 'Actividad borrada exitosamente!',
          icon: 'success',
        })
        getTasksList()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const aboutButtonOptions = {
    text: 'AGREGAR ACTIVIDAD',
    icon: 'add',
    stylingMode: 'text',
    elementAttr: {
      id: 'addicon',
      class: 'prueba',
    },
    onClick: (e) => {
      changeDialog(e)
    },
  }

  const changeDialog = async (e) => {
    e.cancel = true

    setPopupVisible(true)

    if (e.values) {
      setidActivity(Number(e.key))
      // setActivity(e.values.title)
      // setdateStart(Moment(e.values.start).format('YYYY-MM-DD'))
      // setdateEnd(Moment(e.values.end).format('YYYY-MM-DD'))
    }
    formikTable.setFieldValue('Activity', e.values.title)
    formikTable.setFieldValue(
      'dateStart',
      Moment(e.values.start).format('YYYY-MM-DD'),
    )
    formikTable.setFieldValue(
      'dateEnd',
      Moment(e.values.end).format('YYYY-MM-DD'),
    )
  }

  const onDelete = async (e) => {
    handleDelete()
  }

  const onHiding = async () => {
    setPopupVisible(false)
    formikTable.resetForm()
    setActivity('')
    setdateEnd('')
    setdateStart('')
    setidActivity('')
    setErrorActividad(false)
  }

  return (
    <>
      <Gantt
        taskListWidth={500}
        scaleType="months"
        height={260}
        onTaskUpdating={handleInsert}
        onTaskDeleted={handleDelete}
        showResources={false}
        showDependencies={false}
        onTaskEditDialogShowing={changeDialog}
        onTaskDeleting={onDelete}
        taskTitlePosition="none"
        startDateRange={new Date(ImplementationDateStart)}
        endDateRange={new Date(ImplementationDateEnd)}
      >
        <ContextMenu>
          <Item name="taskDetails" />
          <Item name="deleteTask" />
        </ContextMenu>
        <Tasks dataSource={tasks} />

        <Toolbar>
          <Item
            widget="dxButton"
            options={aboutButtonOptions}
            cssClass="prueba"
          />
          <Item name="deleteTask" />
          <Item name="separator" />
          <Item name="zoomIn" />
          <Item name="zoomOut" />
          <Item>
            <div className="informer">
              <a
                data-tip="Para editar hacer doble clic sobre la actividad a modificar."
                data-for="infoCurrencyPop"
                style={{ cursor: 'pointer' }}
              >
                <ErrorOutlineIcon fontSize="small" />
                <ReactTooltip
                  id="infoCurrencyPop"
                  effect="solid"
                  multiline={true}
                  type="dark"
                />
              </a>
            </div>
          </Item>
        </Toolbar>

        <Column dataField="title" caption="Actividad" width={300} />
        <Column dataField="start" caption="Fecha inicio" />
        <Column dataField="end" caption="Fecha fin" />

        {/* <Validation autoUpdateParentTasks /> */}
        <Editing enabled allowResourceAdding={false}></Editing>
      </Gantt>

      <Popup
        title="Nueva actividad"
        showTitle={true}
        width={700}
        height={310}
        visible={popupVisible}
        hideOnOutsideClick={false}
        onHiding={onHiding}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">Actividad</label>
            {/* <a
              data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, diagonal, comillas."
              data-for="info"
              style={{ cursor: 'pointer' }}
            >
              <ErrorOutlineIcon fontSize="small" />
              <ReactTooltip
                id="info"
                effect="solid"
                multiline={true}
                type="dark"
              />
            </a> */}
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeName"
                  style={{ width: '100%' }}
                  variant="outlined"
                  onChange={(e) => {
                    if (
                      e.target.value.match(
                        /[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                      ) ||
                      e.target.value === ''
                    ) {
                      setErrorActividad(false)
                      formikTable.setFieldValue('Activity', e.target.value)
                    } else {
                      setErrorActividad(true)
                    }
                  }}
                  value={formikTable.values.Activity}
                  autoComplete={false}
                  error={formikTable.errors.Activity}
                  inputProps={{ maxlength: 100 }}
                />
                {errorActividad ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    Caracteres especiales no aceptados
                  </div>
                ) : null}
                {formikTable.errors.Activity ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formikTable.errors.Activity}
                  </div>
                ) : null}
              </FormControl>
              <Grid container spacing={1} className="input__container">
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <Stack component="form" noValidate spacing={3}>
                      <TextField
                        id="ImplementationDateStart"
                        label="Fecha Inicio"
                        type="date"
                        name="ImplementationDateStart"
                        variant="outlined"
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          min: Moment(ImplementationDateStart)
                            .format('YYYY-MM-DD')
                            .toString(),
                          max: Moment(ImplementationDateEnd)
                            .format('YYYY-MM-DD')
                            .toString(),
                        }}
                        onChange={(e) => {
                          formikTable.setFieldValue('dateStart', e.target.value)
                        }}
                        value={formikTable.values.dateStart}
                      />
                    </Stack>
                    {formikTable.errors.dateStart ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formikTable.errors.dateStart}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <Stack component="form" noValidate spacing={3}>
                      <TextField
                        id="ImplementationDateEnd"
                        name="ImplementationDateEnd"
                        label="Fecha fin"
                        type="date"
                        variant="outlined"
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) => {
                          setdateEnd(e.target.value)
                          formikTable.setFieldValue('dateEnd', e.target.value)
                        }}
                        value={formikTable.values.dateEnd}
                        inputProps={{
                          min: Moment(formikTable.values.dateStart)
                            .format('YYYY-MM-DD')
                            .toString(),
                          max: Moment(ImplementationDateEnd)
                            .format('YYYY-MM-DD')
                            .toString(),
                        }}
                        error={formikTable.errors.dateEnd}
                      />
                    </Stack>
                    {formikTable.errors.dateEnd ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formikTable.errors.dateEnd}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid className="buttonsPYME">
            <Button className="cancelButton" onClick={onHiding}>
              Cancelar
            </Button>

            <Button
              className="confirmButton"
              onClick={validateFormStatus}
              disabled={loading}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </Popup>
    </>
  )
}

export default GantChartExtreme
